<template>
  <div>
    <div class="brand-logo">
      <BrandLogo
        name="Family Entertainment And Culture"
        :logo="require('../../../assets/brands_logo_1_big.png')"
        desc="Shenzhen Little Orange Castle Culture Communication Co., Ltd."
      ></BrandLogo>
    </div>
    <BrandIntro class="brand-intro" :lineArray="array"></BrandIntro>
    <div class="products">
      <div class="products__block">
        <div class="products__block__title">Performance</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_1.png"
        />
      </div>
      <div class="products__block">
        <div class="products__block__title">Exhibition</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_2.png"
        />
      </div>
      <div class="products__block">
        <div class="products__block__title">Film & TV Shows</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_3.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BrandLogo from "./BrandLogo";
import BrandIntro from "./BrandIntro"
export default {
  data() {
    return {
      array: [
        "Little Orange Castle has become a domestic parent-child performance industry leader",
        "For four consecutive years, it has won the largest market share for performing parent-child performance in mainland China of more than 25%",
        "It has formed three major mature product lines: Family Performance, Art Exhibitions and Films Production",
        "We hold the copyright of 60 independent works",
        "12 self-operated performance production bases, strict cost and quality control",
        "We have performed more than 10000 performances in more than 120 cities across 30 provinces, with an audience over ten million",
        "In three years, the “Little Orange Fort Exhibit” has presented 60 exhibitions in 27 different cities."
      ]
    };
  },
  components: {
    BrandLogo,
    BrandIntro
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  padding: 64px 0 54px 0;
  text-align: center;
}
.brand-intro{
  width: 1200px;
  margin: 0 auto;
}
.products {
  height: 1414px;
  background-color: #1f1f1f;
  overflow: hidden;
  &__block {
    &__title {
      color: #ec6900;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-size: 26px;
      margin-top: 58px;
    }
    &__img {
      display: block;
      margin: 31px auto 0 auto;
    }
  }
}
</style>